import { put, call, takeLatest } from 'redux-saga/effects'
import { getCompany } from '@/core/apiModules/companies'
import { companiesModule } from '../modules'
import { errorHandler } from '@/core/helpers/errorHelpers'

function* fetchDetail({ payload }) {
  yield put(companiesModule.toggleLoadingDetail(true))

  try {
    const response = yield getCompany(payload.companyId)
    yield put(companiesModule.fetchDetailSuccess(response))
  } catch (err) {
    yield call(errorHandler, err)
  } finally {
    yield put(companiesModule.toggleLoadingDetail(false))
  }
}

export default function* watchCompaniesSaga() {
  yield takeLatest(companiesModule.FETCH_DETAIL, fetchDetail)
}
